import(/* webpackMode: "eager" */ "/var/www/admin.dot.nyotek.com/node_modules/next/font/google/target.css?{\"path\":\"src/app/layout.tsx\",\"import\":\"Inter\",\"arguments\":[{\"subsets\":[\"latin\"]}],\"variableName\":\"inter\"}");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/var/www/admin.dot.nyotek.com/src/AntdRegistry.tsx");
;
import(/* webpackMode: "eager" */ "/var/www/admin.dot.nyotek.com/src/app/globals.scss");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/var/www/admin.dot.nyotek.com/src/app/loading.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/var/www/admin.dot.nyotek.com/src/ProtectedRoutes/ProtectedLayout.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/var/www/admin.dot.nyotek.com/src/Utils/AppInitializer.ts");
